<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloAssociacao}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioAssociacao" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>{{nomeCampoAssociacaoPai}}</mat-label>
                            <mat-select value="{{nomeCampoAssociacaoPai}}" formControlName="associacaoPai"
                                name="associacaoPai" id="associacaoPai" required
                                (selectionChange)="onChangePai($event)">
                                <mat-option *ngFor="let pai of listaPais" [value]="pai">
                                    {{pai.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioAssociacao.controls.associacaoPai.hasError('required')">
                                O campo {{nomeCampoAssociacaoPai}} é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <table mat-table [dataSource]="dataSource" class="table table-striped">

                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="nome">
                                <th mat-header-cell *matHeaderCellDef>
                                    {{nomeCampoAssociacaoFilho}}
                                </th>
                                <td mat-cell *matCellDef="let filho"> {{filho.nome}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioAssociacao.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>